import type { Buchungstyp, Periode } from './api'

const euro = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' })

export function betrag(wert: number | null | undefined): string {
  return wert == null ? '' : euro.format(wert)
}

/** ISO-Datum (yyyy-mm-dd) als dd.mm.yyyy. */
export function datum(iso: string | null | undefined): string {
  if (!iso) return ''
  const [j, m, t] = iso.substring(0, 10).split('-')
  return `${t}.${m}.${j}`
}

export function zeitpunkt(iso: string): string {
  return new Date(iso).toLocaleString('de-DE', { dateStyle: 'medium', timeStyle: 'short' })
}

export function heute(): string {
  const d = new Date()
  const zweistellig = (n: number) => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${zweistellig(d.getMonth() + 1)}-${zweistellig(d.getDate())}`
}

/** Nimmt deutsche Eingaben wie "1.234,56" oder "12,5" an und liefert "1234.56" bzw. "12.5". */
export function betragEingabe(text: string): string | null {
  const t = text.trim().replace(/\s|€/g, '')
  if (!t) return null
  const normalisiert = t.includes(',') ? t.replace(/\./g, '').replace(',', '.') : t
  return /^-?\d+(\.\d+)?$/.test(normalisiert) ? normalisiert : null
}

export function betragAlsEingabe(wert: number | null | undefined): string {
  return wert == null ? '' : wert.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 8, useGrouping: false })
}

export const periodeText: Record<Periode, string> = {
  MONATLICH: 'monatlich',
  ZWEIMONATLICH: '2-monatlich',
  QUARTALSWEISE: 'quartalsweise',
  JAEHRLICH: 'jährlich',
}

export const typText: Record<Buchungstyp, string> = {
  EINGANG: 'Eingang',
  AUSGANG: 'Ausgang',
}
